/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Artcraft_P2Inputs */

const en_fc_home_artcraft_p2 = /** @type {(inputs: Fc_Home_Artcraft_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The easiest way to install them is the ArtCraft Launcher, a small desktop app that downloads FilmCraft and the other Crafting Apps and keeps them up to date. You can also download FilmCraft on its own from the official GitHub releases, which is where every link in our download guide points.`)
};

/**
* | output |
* | --- |
* | "The easiest way to install them is the ArtCraft Launcher, a small desktop app that downloads FilmCraft and the other Crafting Apps and keeps them up to date...." |
*
* @param {Fc_Home_Artcraft_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_artcraft_p2 = /** @type {((inputs?: Fc_Home_Artcraft_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Artcraft_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_artcraft_p2(inputs)
});
export { fc_home_artcraft_p2 as "fc.home.artcraft.p2" }